import { render, staticRenderFns } from "./admin_page.vue?vue&type=template&id=76269cce&scoped=true"
import script from "./admin_page.vue?vue&type=script&lang=js"
export * from "./admin_page.vue?vue&type=script&lang=js"
import style0 from "./admin_page.vue?vue&type=style&index=0&id=76269cce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76269cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76269cce')) {
      api.createRecord('76269cce', component.options)
    } else {
      api.reload('76269cce', component.options)
    }
    module.hot.accept("./admin_page.vue?vue&type=template&id=76269cce&scoped=true", function () {
      api.rerender('76269cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/admin_page.vue"
export default component.exports